// @ts-nocheck
import styled from 'styled-components';

import { Flex, IconLock, token } from '@zillow/constellation';

export const StyledBar = styled.div<{ borderColor: string; gridColumnStart: number; gridColumnEnd: number }>`
  grid-row: 1;
  grid-column: ${(props) => props.gridColumn};
  grid-column-start: ${(props) => props.gridColumnStart};
  grid-column-end: ${(props) => props.gridColumnEnd};
  border-width: 4px;
  border-style: solid;
  border-color: ${(props) => props.borderColor};
  border-radius: 10px;
`;

export const StyledIconLock = styled(IconLock)`
  color: ${token('colors.blue400')};
  background-color: ${token('colors.white')};
  border-radius: 50%;
  display: inline-block;
`;

export const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-top: 2px;
  border: 8px solid rgba(7, 77, 255, 0.1)};
  position: absolute;
  height: 36px;
  width: 36px;
  top: -16px;
  margin-left: 45%;
`;

export const StyledIconBackground = styled.div`
  border-radius: 50%;
  border-width: 6px;
  border-style: solid;
  height: 27px;
  width: 27px;
  color: ${token('colors.white')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: ${token('colors.white')};
  background-color: ${token('colors.white')};
  box-shadow: 0px 2px 4px rgba(33, 29, 29, 0.2);
`;

export const StyledContainerGrid = styled.div<{ isLocked?: boolean }>`
  display: grid;
  grid-template-columns: repeat(100, 1fr);
  filter: ${(props) => (props.isLocked ? 'blur(1.5px)' : 'none')};
`;

export const StyledDataPointContainer = styled.div<{ marginLeft: number }>`
  border-radius: 50%;
  margin-top: 2px;
  border: 8px solid rgba(7, 77, 255, 0.1)};
  position: absolute;
  top: 40px;
  margin-left: ${(props) => `${props.marginLeft}%`};
`;

export const StyledDataPoint = styled.div`
  border-radius: 50%;
  border-width: 6px;
  border-style: solid;
  height: 20px;
  width: 20px;
  color: ${token('colors.white')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: ${token('colors.white')};
  background-color: ${token('colors.brand')};
  box-shadow: 0px 2px 4px rgba(33, 29, 29, 0.2);
`;

export const StyledFlexBlur = styled(Flex)`
  filter: blur(1.5px);
`;
